import PropTypes from "prop-types";
import { connect } from "react-redux";

const mapStateToProps = state => ({
    deviceType: state.view.deviceType
});

const ShowForDeviceType = props => {
    if (props.deviceType === "xs" && props.xs) {
        return props.children;
    } else if (props.deviceType === "sm" && props.sm) {
        return props.children;
    } else if (props.deviceType === "md" && props.md) {
        return props.children;
    } else if (props.deviceType === "lg" && props.lg) {
        return props.children;
    } else if (props.deviceType === "xl" && props.xl) {
        return props.children;
    } else {
        return null;
    }
};

ShowForDeviceType.propTypes = {
    deviceType: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool
};
export default connect(mapStateToProps)(ShowForDeviceType);